import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useMemo, useReducer } from 'react';
import createSearchReducer, { initialState, ActionTypes } from './createSearchReducer';
import useSearchActions from './useSearchActions';
export default function useSearchResults(_ref) {
  var inputQuery = _ref.query,
      inputOptions = _objectWithoutProperties(_ref, ["query"]);

  var actions = useSearchActions();
  var query = (inputQuery || '').trim(); // Ensure options only changes when an actual value inside it does.
  // eslint-disable-next-line react-hooks/exhaustive-deps

  var options = useMemo(() => inputOptions, [JSON.stringify(inputOptions)]);

  var _useReducer = useReducer(createSearchReducer({
    query,
    options
  }), initialState, initialState => {
    return _objectSpread(_objectSpread({}, initialState), {}, {
      results: _objectSpread(_objectSpread({}, initialState.results), {}, {
        options
      })
    });
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  useEffect(() => {
    if (!query) {
      dispatch({
        type: ActionTypes.RESET,
        query,
        options
      });
    }
  }, [options, query]);
  useEffect(() => {
    if (query) {
      var getResults = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* () {
          dispatch({
            type: ActionTypes.LOAD_RESULTS_REQUEST,
            query,
            options
          });

          try {
            var response = yield actions.getSearchQueryResults(_objectSpread({
              query
            }, options));
            dispatch({
              type: ActionTypes.LOAD_RESULTS_SUCCESS,
              query,
              options,
              payload: response.payload
            });
          } catch (err) {
            dispatch({
              type: ActionTypes.LOAD_RESULTS_FAILURE,
              query,
              options,
              error: err
            });
          }
        });

        return function getResults() {
          return _ref2.apply(this, arguments);
        };
      }();

      getResults();
    }
  }, [actions, options, query]);
  return useMemo(() => {
    return _objectSpread(_objectSpread({}, state), {}, {
      query,
      options,
      isUpToDate: state.results.query === query && state.results.options === options && !state.isLoading
    });
  }, [options, query, state]);
}